import { get } from 'app/utils/axios/kheti'
import ApiResponse from 'app/models/apiResponse'
import { DemoMaterialRequest } from 'app/models/RequestFlow'

const fetchDemoMaterialRequest = async (
  page: number,
  request_type?: string,
  status?: string,
  roleType?: string,
  created_at_after?: string,
  created_at_before?: string,
  lang = 'en',
) => {
  try {
    const params: Record<string, string> = {
      page: String(page),
      lang,
      page_size: '10',
      ...(roleType && { role_type: roleType }),
      ...(request_type && { request_type }),
      ...(status && { latest_status: status }),
      ...(created_at_after && { created_at_after }),
      ...(created_at_before && { created_at_before }),
    }

    const endpoint =
      roleType === 'L1' || roleType === 'L2'
        ? '/approvals/v1/demo-material-issuance/actions/request'
        : '/approvals/v1/demo-material-issuance/requests'

    const response = await get<ApiResponse<DemoMaterialRequest>>(endpoint, params)
    return response
  } catch (e) {
    console.error('Error fetching demo material requests:', e)
    return null
  }
}

export default fetchDemoMaterialRequest
